import { Component, ViewChild } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { Opi, ApiClientService } from '../../services/api-client.service';
import { CacheService } from '../../services/cache.service';

@Component({
  selector: 'app-opisi',
  templateUrl: './opisi.component.html',
  styleUrls: ['./opisi.component.scss']
})
export class OpisiComponent {
  @ViewChild('opisiGrid', { static: false }) opisiGrid: any;

  gridData: Opi[] = [];
  loading = false;
  isEditPopupVisible = false;
  isCreatePopupVisible = false;
  selectedOpi: Opi | null = null;
  loadPanelPosition = { of: '#opisiGrid' };

  opiForm!: FormGroup;

  constructor(
    private apiClient: ApiClientService,
    private cache: CacheService,
    private fb: FormBuilder
  ) {
    this.initializeForm();
  }

  ngOnInit() {
    this.loadOpisi();
  }

  initializeForm() {
    this.opiForm = this.fb.group({
      opis: ['', Validators.required],
      id: [this.selectedOpi?.id || null],
      // Add other fields as needed based on your Opi model
    });
  }

  async loadOpisi() {
    this.loading = true;
    try {
      this.gridData = await this.apiClient.opisiAll();
    } catch (error) {
      console.error('Error loading opisi:', error);
    } finally {
      this.loading = false;
    }
  }

  onRowClick(e: any) {
    if (e.data) {
      this.selectedOpi = e.data;
    }
  }

  onAddClick() {
    this.selectedOpi = null;
    this.opiForm.reset();
    this.isCreatePopupVisible = true;
  }

  onEditClick() {
    if (this.selectedOpi) {
      this.populateForm(this.selectedOpi);
      this.isEditPopupVisible = true;
    }
  }

  // onDeleteClick() {
  //   if (this.selectedOpi && confirm('Are you sure you want to delete this opi?')) {
  //     this.deleteOpi(this.selectedOpi.id as number);
  //   }
  // }

  populateForm(opi: Opi) {
    this.opiForm.patchValue({
      opis: opi.opis,
      id: opi.id,
    });
  }

  async createOpi() {
    if (this.opiForm.valid) {
      this.loading = true;
      try {
        const formData = this.opiForm.value;
        formData.id = 0; // Ensure ID is zero for creation
        await this.apiClient.opisiPOST(formData);
        this.isCreatePopupVisible = false;
        this.opiForm.reset();
        this.loadOpisi(); // Refresh grid
      } catch (error) {
        console.error('Error creating opi:', error);
      } finally {
        this.loading = false;
      }
    }
  }

  async updateOpi() {
    if (this.opiForm.valid && this.selectedOpi) {
      this.loading = true;
      try {
        const formData = this.opiForm.value;
        await this.apiClient.opisiPUT(this.selectedOpi.id as number, formData);
        this.isEditPopupVisible = false;
        this.loadOpisi(); // Refresh grid
      } catch (error) {
        console.error('Error updating opi:', error);
      } finally {
        this.loading = false;
      }
    }
  }

  // async deleteOpi(id: number) {
  //   this.loading = true;
  //   try {
  //     await this.apiClient.opisiDELETE(id);
  //     this.selectedOpi = null;
  //     this.loadOpisi(); // Refresh grid
  //   } catch (error) {
  //     console.error('Error deleting opi:', error);
  //   } finally {
  //     this.loading = false;
  //   }
  // }

  onEditPopupHidden() {
    this.isEditPopupVisible = false;
    this.selectedOpi = null;
  }

  onCreatePopupHidden() {
    this.isCreatePopupVisible = false;
  }
}
